import { nanoid } from 'nanoid';

type MetaData = {
  _associatedWithId: string | null;
  _existsInDb: boolean;
  _id: string;
  _isRemoved: boolean;
  id: string;
};

type Row = MetaData & Record<string, unknown>;

const createEmptyRow = (): Row => {
  const id = nanoid(25);
  return {
    _associatedWithId: null,
    _existsInDb: false,
    _id: id,
    _isRemoved: false,
    id,
  };
};

export default createEmptyRow;
